module.exports = __webpack_public_path__ + "308ed5e697fb8e9bd3b467e97544ae56.pdf";